import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import useActivityCreate from 'modules/queries/account/activity/create';
import useAuthenticated from 'modules/oidc/useAuthenticated';

export function useUserActiveIntent() {
	const { mutateAsync: activityCreate } = useActivityCreate();
	const { user } = useAuth();
	const isAuthenticated = useAuthenticated();

	const validUser = !isAuthenticated ? undefined : user?.profile?.username;

	useEffect(() => {
		if (!validUser) return;

		activityCreate({
			type: 'User Active',
		}).catch(() => 0);
	}, [validUser, activityCreate]);
}

export function UserActiveIntent() {
	useUserActiveIntent();
	return null;
}

export default UserActiveIntent;
